// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"54d837ab","87":"12893a91","108":"9d8791c5","168":"7a26036c","525":"65240cc0","790":"5bfd044b"}[chunkId] + ".chunk.js";
};